<!--MOBILE NAVIGATION-->
<nav class="mobile-navigation">
  <a
    href="javascript:void(0)"
    (click)="onToggleNavigation(); clearStorage()"
    class="btn btn-transparent mobile-nav-handle">
    <i class="icon cursor small menu blue"></i>
    <span class="sr-only">Toggle Navigation</span>
  </a>
  <div class="mobile-navigation-modal" [style.display]="showModalNav ? 'block' : 'none'">
    <a
      href="javascript:void(0)"
      (click)="onToggleNavigation(); clearStorage()"
      class="btn btn-transparent mobile-nav-handle">
      <i class="icon cursor small plus red"></i>
      <span class="sr-only">Toggle Navigation</span>
    </a>

    <ul>
      <!--SIGN IN MENU FOR MOBILE NAVIGATION-->
      <li *ngIf="(isAuthenticated$ | async) === false">
        <a
          id="mobile-header-login"
          [attr.data-beyond-header-button-id]="'mobile-header-login'"
          routerLink="/login"
          href="javascript:void(0)"
          class="btn btn-transparent">
          <i class="icon red small people-male"></i>
          <span>{{ headerMenu.SIGN_IN }}</span>
        </a>
      </li>
      <!--END SIGN IN MENU FOR MOBILE NAVIGATION-->
      <!--MENU OPTIONS FOR SIGNED IN USERS-->
      <li *ngIf="isAuthenticated$ | async">
        <div class="header-controls header-support resources-mobile">
          <a class="btn btn-transparent" (click)="onToggleUserDropdown()">
            <div class="flexbox">
              <ngContainer
                *ngIf="
                  avatarUrl$ | async as avatarUrl;
                  then thenBlock;
                  else elseBlock
                "></ngContainer>
              <ng-template #thenBlock>
                <span
                  class="header-user-controls"
                  [style.background-image]="'url(' + avatarUrl + ')'">
                  User Controls
                </span>
              </ng-template>
              <ng-template #elseBlock
                ><span class="header-user-controls icon small avatar"> User Controls </span>
              </ng-template>
              <i [ngClass]="!userDropDown ? 'arrow-down' : 'arrow-up'" class="icon red small"></i>
            </div>
            <ul *ngIf="userDropDown">
              <!--MY USER DASHBOARD-->
              <li class="menu-item" (click)="onToggleNavigation()">
                <a routerLink="/dashboard">
                  <span>{{ headerMenu.MY_DASHBOARD }}</span>
                </a>
              </li>
              <!--END MY USER DASHBOARD-->
              <!--EDIT & REDIRECT TO DOCEBO USER PROFILE-->
              <li class="menu-item" (click)="onToggleNavigation()">
                <a href="{{ doceboUrl }}/learn/my-profile">
                  <span>{{ headerMenu.EDIT_PROFILE }}</span>
                </a>
              </li>
              <!--END EDIT & REDIRECT TO DOCEBO USER PROFILE-->
              <!--MESSAGE INBOX COUNT-->
              <li class="menu-item" (click)="onToggleNavigation()">
                <a
                  href="javascript:void(0)"
                  routerLink="/message-inbox"
                  class="btn btn-transparent">
                  <span>{{ headerMenu.MESSAGES }} ({{ messageInboxCount }})</span>
                </a>
              </li>
              <!--END MESSAGE INBOX COUNT-->
              <!--SIGNOUT MENU ITEM-->
              <li class="menu-item" (click)="onToggleNavigation()">
                <a href="javascript:void(0)" (click)="onLogoutClick()" class="btn btn-transparent">
                  <span>{{ headerMenu.SIGN_OUT }}</span>
                </a>
              </li>
              <!--END SIGNOUT MENU ITEM-->
            </ul>
          </a>
        </div>
      </li>
      <!--END MENU OPTIONS FOR SIGNED IN USERS-->
      <li>
        <a routerLink="/search" (click)="onToggleNavigation()" class="btn btn-transparent">
          <i class="icon red small search"></i>
          <span>{{ headerMenu.SEARCH }}</span>
        </a>
      </li>
      <li>
        <div class="header-controls header-support resources-mobile">
          <a (click)="onToggleDropdown(headerMenu.PRODUCTS)" class="btn btn-transparent">
            <i class="icon red small wallet"></i>
            <span>{{ headerMenu.PRODUCTS }}</span>
            <i
              [ngClass]="!isExpandedProducts ? 'arrow-down' : 'arrow-up'"
              class="icon red small"></i>
            <ul *ngIf="isExpandedProducts">
              <ng-container
                *ngFor="
                  let subscriptionItem of subscriptionItems;
                  let i = index;
                  trackBy: trackBySubscriptionItem
                ">
                <ng-container *ngIf="subscriptionItem?.canShowProductInMenu">
                  <li class="menu-item" (click)="onToggleNavigation()">
                    <a href="/subscription/{{ subscriptionItem.slugName }}">
                      <span>{{ subscriptionItem.displayName }}</span>
                    </a>
                  </li>
                </ng-container>
              </ng-container>
            </ul>
          </a>
        </div>
      </li>
      <li>
        <div class="header-controls header-support resources-mobile">
          <a (click)="onToggleDropdown(headerMenu.CATALOG)" class="btn btn-transparent">
            <i class="icon red small wallet"></i>
            <span>{{ headerMenu.CATALOG }}</span>
            <i
              [ngClass]="!isExpandedCatalog ? 'arrow-down' : 'arrow-up'"
              class="icon red small"></i>
            <ul *ngIf="isExpandedCatalog">
              <li class="menu-item" (click)="onToggleNavigation()">
                <a routerLink="/search">
                  <span>Learning by Type</span>
                </a>
              </li>
              <li class="menu-item" (click)="onToggleNavigation()">
                <a routerLink="/search">
                  <span>Learning by Topic</span>
                </a>
              </li>
              <li class="menu-item" (click)="onToggleNavigation()">
                <a routerLink="/search">
                  <span>Learning by Role</span>
                </a>
              </li>
            </ul>
          </a>
        </div>
      </li>
      <li>
        <div class="header-controls header-support resources-mobile">
          <a (click)="onToggleDropdown(headerMenu.RESOURCES)" class="btn btn-transparent">
            <i class="icon red small documentation"></i>
            <span>{{ headerMenu.RESOURCES }}</span>
            <i
              [ngClass]="!isExpandedResources ? 'arrow-down' : 'arrow-up'"
              class="icon red small"></i>
            <ul *ngIf="isExpandedResources">
              <ng-container
                *ngFor="let resource of resourceArray; let i = index; trackBy: trackByResourceName">
                <li class="menu-item" (click)="onToggleNavigation()" *ngIf="resource.display">
                  <a routerLink="{{ resource.routerLink }}">
                    <span>{{ resource.name }}</span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </a>
        </div>
      </li>
    </ul>
  </div>
</nav>
<!--END MOBILE NAVIGATION-->
